import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-contacts-lookup',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './formly-contacts-lookup.component.html',
  standalone: true
})
export class FormlyContactsLookupComponent extends FieldType implements OnInit {

  dataSource: any;

  ngOnInit() {


  }

}
